import styled from 'styled-components';
import {FullContainer} from '@/styled-components';
import {palette} from '@/styles';
import {DottedLoadingBar} from './Loading';

export const Splash = () => {
  return (
    <Root>
      <DottedLoadingBar color={palette.gray400} />
    </Root>
  );
};

const Root = styled(FullContainer)`
  align-items: center;
  justify-content: center;
  text-align: center;
`;
